import { render, staticRenderFns } from "./PayRangeVersionProposalDrawer.vue?vue&type=template&id=fb36a50a&scoped=true"
import script from "./PayRangeVersionProposalDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeVersionProposalDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeVersionProposalDrawer.vue?vue&type=style&index=0&id=fb36a50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb36a50a",
  null
  
)

export default component.exports